/** נתיב ללוגו כללי (בנק לא מזוהה ברשימה) — החליפו בקבצי PNG/SVG רשמיים לפי הצורך */
export const GENERIC_BANK_LOGO = "/bank-logos/generic.svg";

/**
 * רשימת בנקים בישראל — קוד בנק (ספרות) לפי נוהל שיקים / בנק ישראל.
 * ערכי code תואמים לשדה מספר בנק בטפסים בנקאיים.
 * logo — קובץ תחת public/bank-logos (ניתן להחליף בלוגו רשמי).
 */
export const ISRAELI_BANKS = [
  { code: "04", name: "בנק יהב לעובדי המדינה", logo: "/bank-logos/04.svg" },
  { code: "09", name: "בנק הדואר (הבנק הדוארי)", logo: "/bank-logos/09.svg" },
  { code: "10", name: "בנק לאומי לישראל", logo: "/bank-logos/10.svg" },
  { code: "11", name: "בנק דיסקונט לישראל", logo: "/bank-logos/11.svg" },
  { code: "12", name: "בנק הפועלים", logo: "/bank-logos/12.svg" },
  { code: "13", name: "בנק אגוד לישראל", logo: "/bank-logos/13.svg" },
  { code: "14", name: "בנק אוצר החייל", logo: "/bank-logos/14.svg" },
  { code: "17", name: "בנק מרכנתיל דיסקונט", logo: "/bank-logos/17.svg" },
  { code: "20", name: "בנק מזרחי טפחות", logo: "/bank-logos/20.svg" },
  { code: "31", name: "הבנק הבינלאומי הראשון לישראל", logo: "/bank-logos/31.svg" },
  { code: "34", name: "בנק ערבי ישראלי", logo: "/bank-logos/34.svg" },
  { code: "46", name: "בנק מסד", logo: "/bank-logos/46.svg" },
  { code: "52", name: "בנק פאג״י", logo: "/bank-logos/52.svg" },
  { code: "54", name: "בנק ירושלים", logo: "/bank-logos/54.svg" },
];

const CODE_SET = new Set(ISRAELI_BANKS.map((b) => b.code));

/**
 * @param {string|number|null|undefined} raw
 * @returns {string}
 */
export function normalizeIsraeliBankCode(raw) {
  const d = String(raw ?? "").replace(/\D/g, "");
  if (!d) return "";
  if (d.length === 1) return `0${d}`;
  if (d.length === 2) return d;
  return d.slice(0, 2);
}

/**
 * @param {string} code
 * @returns {string|undefined}
 */
export function getIsraeliBankNameByCode(code) {
  const n = normalizeIsraeliBankCode(code);
  return ISRAELI_BANKS.find((b) => b.code === n)?.name;
}

/**
 * @param {string} code
 * @returns {string}
 */
export function getIsraeliBankLogoByCode(code) {
  const n = normalizeIsraeliBankCode(code);
  return ISRAELI_BANKS.find((b) => b.code === n)?.logo || GENERIC_BANK_LOGO;
}

/**
 * @param {string} code
 */
export function isKnownIsraeliBankCode(code) {
  return CODE_SET.has(normalizeIsraeliBankCode(code));
}
